/* eslint-disable react/react-in-jsx-scope */
import { Link, ListItemText, Stack, Tooltip, Typography } from '@mui/material';
import { Organisation } from '../../../types/user';
import { Clear, Done, StarRate } from '@mui/icons-material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

export const UserTableRow: GridColDef[] = [
	{
		field: 'name',
		headerName: 'Name',
		sortable: true,
		flex: 1,
		display: 'flex',
		renderCell: (params: GridRenderCellParams) => (
			<Typography data-testid={`user-row-${params.row.name}`} component="span">
				{params.row.name}
			</Typography>
		),
	},
	{
		field: 'email',
		headerName: 'Email Address',
		flex: 1,
		display: 'flex',
		renderCell: (params: GridRenderCellParams) =>
			params.row.email ? (
				<Link href={`mailto:${params.row.email}`}>{params.row.email}</Link>
			) : (
				<Typography component="span">Unknown</Typography>
			),
	},
	{
		field: 'orgs',
		headerName: 'Organisations',
		flex: 1,
		display: 'flex',
		renderCell: (params: GridRenderCellParams) =>
			params.row.organisations.length > 0 ? (
				<Stack data-testid={`${params.row.name}-orgs`}>
					{params.row.organisations.map(
						(
							org: Organisation & {
								pointOfContact: boolean;
							}
						) => {
							return (
								<ListItemText
									key={`${params.row.email}-${org.name}-cell`}
									primary={
										<>
											{org.name}{' '}
											{org.pointOfContact && (
												<Tooltip title={'Point of Contact'}>
													<StarRate fontSize="inherit" data-testid={`${params.row.name}-poc-indicator`} />
												</Tooltip>
											)}
										</>
									}
									secondary={
										<Stack direction={'column'} component={'span'}>
											{org.roles.map((role) => (
												<Typography
													key={`${params.row.email}-${org.name}-${role}-text`}
													component={'span'}
													paddingLeft={2}
												>{` - ${role}`}</Typography>
											))}
										</Stack>
									}
								></ListItemText>
							);
						}
					)}
				</Stack>
			) : (
				<Typography data-testid={`no-orgs-indicator`} component="span">
					No Organisations Assigned
				</Typography>
			),
	},
	{
		field: 'lastSignIn',
		headerName: 'Last Sign In',
		sortable: true,
		flex: 1,
		display: 'flex',
		renderCell: (params: GridRenderCellParams) => (
			<Typography component="span">{new Date(params.row.lastSignIn).toLocaleString()}</Typography>
		),
	},
	{
		field: 'touAgreed',
		headerName: 'TOU Agreed?',
		flex: 0.5,
		display: 'flex',
		headerAlign: 'center',
		align: 'center',
		renderCell: (params: GridRenderCellParams) =>
			params.row.touAgreed ? (
				<Done data-testid={`${params.row.name}-tou-agreed-true`} />
			) : (
				<Clear data-testid={`${params.row.name}-tou-agreed-false`} />
			),
	},
];
